import { useRouter } from 'next/router';

// known top-level nav items in udacity-header
export enum NavItemId {
  Catalog = 'catalog',
  Dashboard = 'dashboard',
  Government = 'government',
  Outcomes = 'outcomes',
  Plans = 'plans',
  Sessions = 'sessions',
  Assessments = 'skillAssessments',
  Individual = 'individuals',
  MastersInAI = 'masters-artificial-intelligence',
}

const BASE_ROUTE_ID_MAP = {
  catalog: NavItemId.Catalog,
  dashboard: NavItemId.Dashboard,
  government: NavItemId.Government,
  'career-outcomes': NavItemId.Outcomes,
  plans: NavItemId.Plans,
  sessions: NavItemId.Sessions,
  assessment: NavItemId.Assessments, // legacy redirect
  assessments: NavItemId.Assessments,
  experience: NavItemId.Individual,
  'masters-artificial-intelligence': NavItemId.MastersInAI,
};

export function getActiveRouteId(asPath: string): string {
  const pathOnly = asPath.split(/[?#]/)[0];
  const baseSegment = pathOnly.split('/')[1];
  // First try exact match from map
  const exactMatch = BASE_ROUTE_ID_MAP[baseSegment as keyof typeof BASE_ROUTE_ID_MAP];
  if (exactMatch) return exactMatch;

  if (pathOnly.startsWith('/org/') && pathOnly.endsWith('/catalog')) {
    return NavItemId.Catalog;
  }

  // No match found
  return '';
}

export function useActiveRouteId() {
  const { asPath } = useRouter();
  return getActiveRouteId(asPath);
}
